(() => {
  const DESKTOP_BP = 990;
  const isDesktop = () =>
    window.innerWidth >= DESKTOP_BP && matchMedia('(hover: hover)').matches;

  const closeSiblings = (el) => {
    const sibs = el.parentElement?.querySelectorAll('details[open]');
    sibs && sibs.forEach((d) => { if (d !== el) d.removeAttribute('open'); });
  };

  const bind = () => {
    const detailsList = document.querySelectorAll(
      'header-menu details, details-disclosure details, .header__inline-menu details'
    );

    detailsList.forEach((d) => {
      if (d.__hoverBound) return;
      d.__hoverBound = true;
      d.__closeTimer = null;

      const openNow = () => {
        if (!isDesktop()) return;
        clearTimeout(d.__closeTimer);
        d.setAttribute('open', '');
        closeSiblings(d);
      };

      const scheduleClose = () => {
        if (!isDesktop()) return;
        clearTimeout(d.__closeTimer);
        d.__closeTimer = setTimeout(() => {
          // only close if focus isn't inside (keyboard users)
          if (!d.contains(document.activeElement)) d.removeAttribute('open');
        }, 200); // <- small delay prevents flicker when crossing small gaps
      };

      // pointer* is better than mouse* across devices
      d.addEventListener('pointerenter', openNow);
      d.addEventListener('pointerleave', scheduleClose);

      // Keep it open if you move into the submenu quickly
      const panel =
        d.querySelector('.mega-menu, .submenu, [role="menu"], nav ul, .header__submenu');
      if (panel) {
        panel.addEventListener('pointerenter', openNow);
        panel.addEventListener('pointerleave', scheduleClose);
      }

      // Keyboard
      d.addEventListener('focusin', openNow);
      d.addEventListener('focusout', (e) => {
        const next = e.relatedTarget;
        if (!next || !d.contains(next)) scheduleClose();
      });
    });
  };

  const unbindMobile = () => {
    if (isDesktop()) return;
    document.querySelectorAll('details[open]').forEach((d) => d.removeAttribute('open'));
  };

  document.addEventListener('DOMContentLoaded', () => {
    bind();
    unbindMobile();
  });
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('resize', unbindMobile);
})();
